const localStorageData = JSON.parse(localStorage.getItem('user_Details'));
console.log(localStorageData);
const getAccessToken = () => localStorage.getItem('access_token');
const getUserName = () => localStorageData && localStorageData?.first_name;
console.log(getUserName());
module.exports = { getUserName, getAccessToken };